import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { IncludesSection } from './components/IncludesSection';
import { AudienceSection } from './components/AudienceSection';
import { EmotionalClose } from './components/EmotionalClose';
import { FinalCTA } from './components/FinalCTA';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
    window.fbq('init', '1609417253435117');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#FBF7F4] text-[#2D2A26] font-sans selection:bg-[#C4A08A] selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <IncludesSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <EmotionalClose data-id="element-7" />
      <FinalCTA data-id="element-8" />

      <footer className="py-8 text-center text-[#2D2A26]/40 text-sm bg-[#FBF7F4] border-t border-[#8B7355]/10" data-id="element-9">
        <p data-id="element-10">
          © {new Date().getFullYear()} PIEL EN PERI. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}